import { all, takeLatest } from 'redux-saga/effects'

import { categoryApi } from '../../../services/'
import {
  createCategoryRequest,
  getCategoryDetailRequest,
  getCategoryListRequest,
  updateCategoryRequest
} from '../actions'
import { createCategorySaga } from './createCategory'
import { getCategoryDetailSaga } from './getCategoryDetail'
import { getCategoryListSaga } from './getCategoryList'
import { updateCategorySaga } from './updateCategory'

export function* categorySaga() {
  try {
    yield all([
      takeLatest(
        getCategoryListRequest as any,
        getCategoryListSaga,
        categoryApi
      ),
      takeLatest(
        getCategoryDetailRequest as any,
        getCategoryDetailSaga,
        categoryApi
      ),
      takeLatest(createCategoryRequest as any, createCategorySaga, categoryApi),
      takeLatest(updateCategoryRequest as any, updateCategorySaga, categoryApi)
    ])
  } catch (err) {
    // TODO: handle error
  }
}
